import { Text } from "@chakra-ui/react";
import { BsFillPersonFill } from "react-icons/bs";
import { IoIosCreate } from "react-icons/io";
import { PiStrategyBold } from "react-icons/pi";

export const satisfiedBenefits = [
  {
    icon: <BsFillPersonFill size={36} />,
    title: "Individuelle Beratung",
    text: (
      <Text>
        Bei uns bekommst du persönliche Beratung und maßgeschneiderte Lösungen
        für deine <strong>Webdesign-Anfragen</strong>. Unser Team in
        <b> Kiel</b> steht bereit, um deine individuellen Bedürfnisse zu
        verstehen und umzusetzen.
      </Text>
    ),
  },
  {
    icon: <IoIosCreate size={36} />,
    title: "Kreatives Design",
    text: (
      <Text>
        Unser erfahrenes <strong>Team von Webdesignern</strong> kreiert
        einzigartige und ansprechende Designs, die deine Marke zum Strahlen
        bringen. Entdecke, wie unser kreatives Team deine Webseite zu etwas
        Besonderem macht.
      </Text>
    ),
  },
  {
    icon: <PiStrategyBold size={36} />,
    title: "Erfolgsorientierte Strategien",
    text: (
      <Text>
        Entwickle mit uns erfolgsorientierte Strategien, um deine Online-Präsenz
        zu stärken. Als <strong>Webdesign-Agentur</strong> wissen wir, wie
        wichtig eine zielgerichtete Strategie ist, um deine Ziele zu erreichen
        und deine Sichtbarkeit zu erhöhen.
      </Text>
    ),
  },
];
